
import { Col, Row } from 'reactstrap';
import ValidationField from '../../../Components/ValidationField/ValidationField';

function Form() {

  const typeselect = [
    {label : "website" , value : "website"},
    {label : "mobile" , value : "mobile"},


  ]
  return (
    <Row xs={1} sm={1} md={1} lg={2} xl={2}>
      <Col>
        <ValidationField name="title" />

        <ValidationField name="description" />

      </Col>
      <Col>
      <ValidationField name="logo" type='File' />
      <ValidationField name="type" type='Select' option={typeselect}  />

      </Col>



    </Row>
  )
}

export default Form




